// @enum_frontend
export function gameStatusStyle(){
    return {
      "toPlay": {
        'color': '#2acc73'
      },
      
      "toBeConfirmed": {
        'color': '#269de2',
      },

      "disputedResult": {
        'color': '#ff9300',
      },
  
      "played": {
        'color': '#2acccc',
      },
    }
  }
  
  export default gameStatusStyle;